/* eslint-disable no-nested-ternary */
/* eslint-disable no-undef */
import React from "react";
import { TextField, styled, Box, IconButton, MenuItem } from "@mui/material";
import DateRangeIcon from "@mui/icons-material/DateRange";

import Icon from "./CustomIcon";
import { IconColors } from "../../Constants/AssetsConstants";
import CommonCircularProgress from "../../LoaderComponents/CommonCirculerProgress";

const RedditTextField = styled((props) => (
  <TextField
    {...props}
    InputProps={{
      disableUnderline: true,
      endAdornment: props.inputLoader && <CommonCircularProgress />,
      ...props.InputProps,
    }}
    size="small"
  />
  // eslint-disable-next-line no-empty-pattern
))((props) => ({
  "& .MuiFilledInput-root": {
    padding: props?.fromAutoComplete ? "auto" : 0,
    margin: props?.fromAutoComplete ? "auto" : 0,
    overflow: "hidden",
    backgroundColor: "#fff",
    fontFamily: "PoppinsRegular",
    paddingLeft: props.textArea && "5px",
    paddingTop: props.textArea && "5px",

    "&:hover": {
      backgroundColor: "#fff",
    },

    // Use the system font instead of the default Roboto font.

    "&.Mui-focused": {
      backgroundColor: "#fff",
      fontFamily: "PoppinsRegular",
    },
    "& .Mui-disabled": {
      color: "#343A40",
      "-webkit-text-fill-color": "unset",
      backgroundColor: "#E0E0E0",
    },

    "& .MuiInputBase-input": {
      paddingTop: props.otpBox && "5px",
      height: props.otpBox && "30px",
      width: props.otpBox && "30px",
      fontFamily: props.otpBox && "PoppinsBold",
      fontSize: props.otpBox && "large",
      textAlign: props.otpBox && "center",
    },
  },
  "& .Mui-disabled": {
    color: "#343A40",
    "-webkit-text-fill-color": "unset",
    // backgroundColor: "rgba(0, 0, 0, 0.12)",
  },

  "& .MuiInputLabel-root": {
    fontFamily: "PoppinsRegular",
    "&.Mui-focused": {
      color: "#9b9b9b",
      fontFamily: "PoppinsRegular",
    },
  },
}));

const InputField = (props) => {
  return (
    <Box
      sx={{
        backgroundColor: "#fff",
        display: "flex",
        alignItems: "center",
        borderRadius: "6px",
        boxShadow: "0 0 20px 0 rgba(0, 0, 0, 0.16)",
        // height: "60px"
        width: props.width,
        padding: props.icon ? "0 10px" : "unset",
        margin: props.customMargin ? props.customMargin : "20px auto",
        overflow: "hidden",
        maxWidth: props.maxWidth,
      }}
      onClick={() => {
        if (props.date) {
          props.handleDatePicker();
        }
      }}
      className={props.className}
    >
      {props.icon ? (
        <Icon
          icon={props.icon}
          color={IconColors.ICON_GRAY}
          size={props.inputType ? (props.fromSignUp ? 38 : 28) : 23}
          onClick={props.iconOnClick}
        />
      ) : null}
      {props.inputType === "phone" ? props.countrycode : null}
      <RedditTextField
        label={props.label}
        id="reddit-input"
        variant="filled"
        style={{ width: "100%" }}
        {...props}
      >
        {props.select &&
          props.optionArray.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
      </RedditTextField>
      {props.date && (
        <IconButton onClick={props.handleDatePicker} style={{ marginRight: 10 }}>
          {" "}
          <DateRangeIcon />{" "}
        </IconButton>
      )}
    </Box>
  );
};

export default InputField;
